
window.cartDrawer=function(open){
  var d=document.getElementById('cartDrawer'),s=document.getElementById('cartScrim'),body=document.getElementById('cartDrawerBody');
  if(!d)return;
  if(open&&window.matchMedia&&matchMedia('(max-width:760px)').matches&&Date.now()-(window.__justAdded||0)<400){
    var f=document.getElementById('cartFab');
    if(f){f.classList.remove('fab-pulse');void f.offsetWidth;f.classList.add('fab-pulse')}
    return;
  }
  if(open){
    var src=document.querySelector('#view-cart > .cart-page')||document.querySelector('#view-cart > .wrap');
    if(src&&!body.contains(src))body.appendChild(src);
    d.hidden=false;s.hidden=false;
    requestAnimationFrame(function(){d.classList.add('open')});
  }else{
    if(d.hidden)return;
    d.classList.remove('open');
    setTimeout(function(){
      d.hidden=true;s.hidden=true;
      var v=document.getElementById('view-cart');
      if(body.firstChild&&v)v.appendChild(body.firstChild);
    },220);
  }
};
window.cartKeepShopping=function(){
  var d=document.getElementById('cartDrawer');
  if(d&&!d.hidden){cartDrawer(false);return}
  var p=window.__prevView;
  go(p&&p!=='cart'?p:'products');
};
if(window.matchMedia&&matchMedia('(hover:hover)').matches){
  document.querySelectorAll('[data-mega]').forEach(function(btn){
    btn.addEventListener('mouseenter',function(){
      var m=document.getElementById('mega-'+btn.getAttribute('data-mega'));
      if(m&&!m.classList.contains('open'))btn.click();
    });
  });
  document.querySelectorAll('.mega').forEach(function(m){
    m.addEventListener('mouseleave',function(){if(typeof closeMegas==='function')closeMegas()});
  });
}
